module.exports = "query GetMarketingParagraphById($id: ID!) {\n  paragraph(id: $id) {\n    ...MarketingParagraphFragment\n  }\n}\n"